import $ from 'jquery';

$.fn.extend({
    hasClasses: function (selectors) {
        let self = this;

        if (!selectors.length) {
            return true;
        }

        for (let i in selectors) {
            if ($(self).hasClass(selectors[i]))
                return true;
        }
        return false;
    }
});

export default () => {
    let faqFilters  = $('.js-faq-filter');
    let faqSearch   = $('.js-faq-search');
    let faqList     = $('.js-faq-list');
    let faq         = $('.js-faq');
    let filters     = [];
    let searchRegex = '';

    faq.on('click', function () {
        this.classList.toggle('active');
    });

    let filterFaq = () => {
        faq.each(function (index, item) {
            let _item = $(item);
            let filterRegex = new RegExp('\\b' + searchRegex, 'gi');

            let condition = !_item.hasClasses(filters) || !item.innerText.match(filterRegex);

            _item.toggleClass('hidden', condition);
        })
    };

    let faqFiltersOnClick = (_this = null) => {
        filters = [];

        faqSearch.val('');
        faqSearch.removeClass('active');
        searchRegex = '';

        if (_this.hasClass('active')) {
            _this.removeClass('active');
        } else {
            faqFilters.removeClass('active');
            _this.addClass('active');

            let filterClass = _this.data('value');
            filters.push(filterClass);
        }

        filterFaq();
    }

    faqFilters.on('click', function () {
        faqFiltersOnClick($(this));
    });

    faqSearch.on('input', function () {
        let currentInput = faqSearch.val();
        faqSearch.toggleClass('active', currentInput !== '');
        searchRegex = currentInput;

        filterFaq();
    });
};